<!-- 提交模板 -->
<template>
  <div class="submit_wrap">
    <div class="submit_price_wrap">
      <div
        class="submit_price"
        @click="handlePriceDetail"
      >
        <div class="price_wrap">
          <div
            class="price_payable"
            :class="!isUseCoupons ? 'no_use_coupons' : ''"
          >
            <span class="price_icon">{{ currency }}</span>{{ payable }}
          </div>
          <div
            v-if="isUseCoupons"
            class="price_discount"
          >
            {{ currency }}{{ oldPayable }}
          </div>
        </div>
        <van-icon
          v-show="payable > 0"
          class="price_detail"
          :name="isDetail ? 'arrow-down' : 'arrow-up'"
        />
      </div>
    </div>
    <!-- 优惠码按钮 -->
    <div
      @click="handleUseCoupon"
      class="coupon_btn"
    >{{$t('footerbtn.coupon.text')}}</div>
    <van-button
      :disabled="!canSubmit || submiting"
      :loading="submiting"
      type="info"
      class="submit_btn"
      :loading-text="$t('footerbtn.btntext.submiting')"
      @click="handleSubmitBtn"
    >{{btnText}}</van-button>
  </div>
</template>

<script>
export default {
  props: {
    isDetail: {
      type: Boolean,
      default: false,
    },
    payable: {
      type: Number,
      default: 0,
    },
    oldPayable: {
      type: Number,
      default: 0,
    },
    isUseCoupons: {
      type: Boolean,
      default: false,
    },
    canSubmit: {
      type: Boolean,
      default: true,
    },
    hasProduct: {
      type: Boolean,
      default: false,
    },
    currency: {
      type: String,
      default: '￥',
    },
    submiting: {
      type: Boolean,
      default: false
    },
  },
  name: 'SubmitComponent',
  data() {
    return {
      params: {},
    }
  },
  computed: {
    btnText() {
      let str = this.$t('footerbtn.btntext.submit')
      let name = this.$route.name
      if (name == 'Ticket') {
        str = this.$t('footerbtn.btntext.next')
      }
      return str
    }
  },

  components: {},

  methods: {
    // 点击查看已选商品详情
    handlePriceDetail() {
      this.$emit('listenHandleShowPriceDetail')
    },
    // 点击提交
    handleSubmitBtn() {
      let pageName = this.$route.name
      // alert(pageName)
      if (pageName === 'Ticket') {
        this.$emit('listenUseCoupon', false)
        this.$emit('listenHandleShowPriceDetail', false)
        this.$router.push({
          name: 'Form',
          params: {
            accountid: this.params.accountid,
            projectid: this.params.projectid,
            language: this.$i18n.locale
          },
        })
      } else { //else if (pageName === 'Form')

        this.$emit('listenWannasubmitForm')
      }
    },
    // 判断是否需要返回商品列表页
    checkIsNeedToBack() {
      let pageName = this.$route.name
      if (pageName === 'Form' && !this.hasProduct) {
        this.$router.push({
          name: 'Ticket',
          params: {
            accountid: this.params.accountid,
            projectid: this.params.projectid,
            language: this.$i18n.locale
          },
        })
      }
    },
    // 点击使用优惠码
    handleUseCoupon() {
      this.$emit('listenUseCoupon')
    },
    // 获取参数信息
    GetParamsData() {
      return new Promise(resolve => {
        this.params = this.$route.params;
        resolve();
      });
    },
  },

  mounted() {
    this.GetParamsData().then(() => {
      this.checkIsNeedToBack()
    })
  },
}
</script>
<style lang="less" scoped>
.submit_wrap {
  position: fixed;
  z-index: 80;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  .submit_price_wrap {
    flex: 1;
    display: flex;
    .submit_price {
      display: flex;
      .price_wrap {
        flex: 1;
        box-sizing: border-box;
        height: 40px;
        padding: 5px 0;
        .price_payable {
          letter-spacing: 1px;
          color: #ed4014;
          font-size: 16px;
          line-height: 18px;
          .price_icon {
            font-size: 14px;
          }
        }
        .no_use_coupons {
          line-height: 30px;
        }
        .price_discount {
          font-size: 12px;
          text-decoration-line: line-through;
          color: #999;
          padding-left: 5px;
          letter-spacing: 1px;
        }
      }
      .price_detail {
        margin-left: 5px;
        font-size: 18px;
        line-height: 40px;
        color: var(--bgColor);
      }
    }
  }
  .coupon_btn {
    // --- 2020-10-09 17:31 隐藏优惠码按钮
    display: none;
    // ---
    height: 40px;
    // width: 40px;
    min-width: 40px;
    padding: 0 8px;
    box-sizing: border-box;
    text-align: center;
    margin-right: 10px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    opacity: 0.7;
    background-color: var(--bgColor);
    color: var(--fontColor);
  }
  .submit_btn {
    height: 40px;
    letter-spacing: 3px;
    padding: 0 25px;
    font-size: 14px;
    // font-weight: bold;
    border-radius: 4px;
    box-sizing: border-box;
    min-width: 120px;
    max-width: 160px;
    background-color: var(--bgColor);
    border-color: var(--bgColor);
    color: var(--fontColor);
    span {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
